import React, { useCallback, useEffect, useState } from 'react'
import Dialog from '../../../../dialog/Dialog'
import { useDispatch, useSelector } from 'react-redux';
import { updateDevelopmentalRubricPreview, updateDevelopmentalRubricForm } from '../../../../../store/actions/developmental-rubrics.actions';
import { getDevelopmentalRubricById } from '../../../../../services/developmental-rubrics/developmental-rubrics.service';
import DevelopmentalRubricSkeleton from '../../../../skeleton/DevelopmentalRubricSkeleton';
import { handlerErrorV2 } from '../../../../../utils/errors';
import FormPreview from '../FormPreview/FormPreview';
import { Alert } from '@mui/material';

const Preview = ({ curriculumId }) => {
  const preview = useSelector((state) => state?.dr?.preview || null)
  const previewType = useSelector((state) => state?.dr?.previewType || null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const dispatch = useDispatch()

  const onLoad = useCallback(async () => {
    if (preview && !['create', 'edit'].includes(preview)) {
      setLoading(true)
      try {
        const response = await getDevelopmentalRubricById(curriculumId, preview)
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred')
        } else {
          const formData = response?.data || {}
          dispatch(updateDevelopmentalRubricForm(formData))
        }

      } catch (error) {
        const message = handlerErrorV2(error)
        setError(message)
      } finally {
        setLoading(false)
      }
    }
  }, [curriculumId, preview])

  const onClose = () => {
    dispatch(updateDevelopmentalRubricPreview())
    if (!['create', 'edit'].includes(preview))  {
      dispatch(updateDevelopmentalRubricForm({}))
    }
  }

  useEffect(() => {
    onLoad()
  }, [onLoad])

  if (!preview) return <></>

  return (
    <Dialog
      id="developmental-rubric-preview"
      show={!!preview} 
      title="developmental rubric preview"
      onClose={onClose}
      onCloseHeader={true}
      maxWidth='lg'
    >
      { error ?
        <Alert severity='error'>{error}</Alert>
      : loading 
        ? <DevelopmentalRubricSkeleton />
        : <FormPreview previewType={previewType} />
      }
    </Dialog>
  )
}

export default Preview